import script from "./TeamsSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamsSection.vue?vue&type=script&lang=ts&setup=true"

import "./TeamsSection.vue?vue&type=style&index=0&id=9b25cea8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b25cea8"]])

export default __exports__